import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourTransformation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="start-your-transformation" className="dark bg-background text-foreground relative flex min-h-[600px] w-full items-center justify-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1558991/img/nairobi_skyline_night_blur.png')] bg-cover bg-center bg-no-repeat opacity-60 blur-[2px]" />
        <div className="absolute inset-0 bg-black/70" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.8)_100%)]" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}>
        <div className="mx-auto max-w-4xl space-y-12">
          {}
          <h2 className="font-sans text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">
            <span className="bg-gradient-to-r from-[hsl(45,100%,50%)] via-[hsl(45,100%,70%)] to-[hsl(45,100%,50%)] bg-clip-text text-transparent drop-shadow-sm">
              Ready to lead the next digital wave?
            </span>
          </h2>

          {}
          <div className="relative inline-flex items-center justify-center">
            {}
            <div className="absolute inset-0 -z-10 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite] rounded-full bg-[hsl(45,100%,50%)] opacity-20" />
            <div className="absolute inset-0 -z-10 animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite] rounded-full bg-[hsl(45,100%,50%)] opacity-10 delay-300" />
            
            {}
            <Button asChild size="lg" className="relative h-16 rounded-full border border-[hsl(45,100%,50%)]/30 bg-background/10 px-10 text-lg font-semibold text-[hsl(45,100%,70%)] backdrop-blur-md transition-all hover:bg-[hsl(45,100%,50%)] hover:text-black hover:shadow-[0_0_40px_-10px_hsl(45,100%,50%)]">
              <Link to="/ConnectPage">
                Book a Strategy Session
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}